import { FaRegUserCircle } from "react-icons/fa";
import { MdCategory } from "react-icons/md";
import { IoMdSettings } from "react-icons/io";
import { BiSolidPackage } from "react-icons/bi";
import { BiSupport } from "react-icons/bi";
import { LuClipboardList } from "react-icons/lu";
import { FaSearch } from "react-icons/fa";
import {FiMail} from "react-icons/fi";
import { FaMessage } from "react-icons/fa6";
import { TbReportMoney } from "react-icons/tb";
import { TbMessageShare } from "react-icons/tb";

export const dataSidebar = [


    {
        link: "/",
        title: "کاربران",
        icon: <FaRegUserCircle/>,
    },
    // {
    //     link: "/botManagement",
    //     title: "مدیریت ربات",
    //     icon: <AiFillProduct/>,
    //     subItem: [
    //         {
    //             link: "/user/activeUser",
    //             title: "active users",
    //         }
    //     ]
    // },
    {
        link: "/packages",
        title: "پکیج ها",
        icon: <BiSolidPackage/>,

    },
    {
        link: "/category",
        title: "دسته بندی",
        icon: <MdCategory/>,

    },
    {
        link: "/setting",
        title: "تنظیمات",
        icon: <IoMdSettings/>,

    },
    {
        link: "/poshtibani",
        title: "پشتیبانی",
        icon: <BiSupport/>,

    },
    {
        link: "/gozareshat",
        title: "گزارشات",
        icon: <LuClipboardList/>,

    },
    {
        link: "/transactionReports",
        title: "گزارش تراکنش ها",
        icon: <TbReportMoney size={22}/>,

    },
    {
        link: "/crawler",
        title: "جست و جو گر",
        icon: <FaSearch></FaSearch>,

    },
    {
        link: "/crawlerDataTable",
        title: "آگهی های دریافتی",
        icon: <FiMail/>,
    },
    {
        link: "/massages-sender",
        title: "ارسال پیام",
        icon: <TbMessageShare/>,
    },
    {
        link: "/sendMessages",
        title: "پیام های ارسال شده",
        icon: <FaMessage/>,
    },

]